import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import { cn } from "./_utils";

/**
 * Checkbox built on Radix Checkbox (supports controlled + indeterminate states).
 * The indeterminate state ("some selected") renders a dash, not a check.
 *
 * @example
 * <Checkbox checked={done} onCheckedChange={setDone} />
 * <Checkbox defaultChecked />
 * <Checkbox checked="indeterminate" />
 */
export function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  const indeterminate = props.checked === "indeterminate";
  return (
    <CheckboxPrimitive.Root
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-[var(--radius-stamp)] border border-border " +
          "bg-bg-input " +
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus " +
          "disabled:cursor-not-allowed disabled:opacity-50 " +
          "data-[state=checked]:bg-accent data-[state=checked]:border-accent " +
          "data-[state=checked]:text-text-inverse " +
          "data-[state=indeterminate]:bg-accent data-[state=indeterminate]:border-accent " +
          "data-[state=indeterminate]:text-text-inverse",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
        {indeterminate ? <Minus className="h-3 w-3" /> : <Check className="h-3 w-3" />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
